// src/components/steps/PersonalInfo.js
import React from "react";
import { Row, Col, Form, Input, DatePicker, Select } from "antd";

const { Option } = Select;

export default function PersonalInfo() {
  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} sm={12}>
        <Form.Item name="first_name" label="First name" rules={[{ required: true, message: "First name is required" }]}>
          <Input placeholder="First name" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="last_name" label="Last name" rules={[{ required: true, message: "Last name is required" }]}>
          <Input placeholder="Last name" />
        </Form.Item>
      </Col>

      <Col xs={24} sm={8}>
        <Form.Item name="roll_number" label="Roll number" rules={[{ required: true, message: "Roll number is required" }]}>
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24} sm={8}>
        <Form.Item name="dob" label="Date of birth" rules={[{ required: true, message: "Date of birth is required" }]}>
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>
      </Col>

      <Col xs={24} sm={8}>
        <Form.Item name="gender" label="Gender" rules={[{ required: true, message: "Gender is required" }]}>
          <Select placeholder="Select">
            <Option value="MALE">Male</Option>
            <Option value="FEMALE">Female</Option>
            <Option value="OTHER">Other</Option>
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="email" label="Email" rules={[{ type: "email", required: true, message: "Valid email required" }]}>
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24} sm={12}>
        <Form.Item name="phone" label="Phone" rules={[{ required: true, message: "Phone is required" }]}>
          <Input />
        </Form.Item>
      </Col>
    </Row>
  );
}
